import {AfterViewInit, Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appThousandSeparator]'
})

export class ThousandSeparatorDirective implements AfterViewInit {

  public el: HTMLInputElement;

  private readonly THOUSANDS_SEPARATOR: string;

  private hasFocus = false;

  constructor(public elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
    this.THOUSANDS_SEPARATOR = ' ';
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.hasFocus = true;
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.hasFocus = false;
  }

  @HostListener('keyup', ['$event.target.value'])
  onKeyUp(value) {
    this.el.value = this.addThousandsSeparator(this.removeThousandsSeparator(value));
  }

  private addThousandsSeparator(value): string {
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);
  }

  private removeThousandsSeparator(value): string {
    return value.replace(/\s/g, '');
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.hasFocus) {
        this.el.value = this.addThousandsSeparator(this.el.value);
      }
    }, 10);
  }
}
